export default {
    success: $localize `Success`,
    failed: $localize `Failed`,
    pending: $localize `Pending`,
    initiated: $localize `Initiated`,
    accepted_from_customer: $localize `Accepted from customer`,
    received_from_employee: $localize `Received from employee`,
}